import React from "react";
import { Link } from "react-router-dom";

const WebsiteFooter = () => {
  return (
    <>
      <div
        class="rts-footer-area rts-section-gapTop bg_footer-1 bg_image"
        id="footer"
      >
        <div class="container">
          <div class="row footer-one">
            <div class="col-lg-4">
              <div class="footer-wrapper-left-one">
                <a href="#" class="logo">
                  <img src="assets/images/about/footr-logo.png" alt="logo" />
                </a>
                {/* <p class="disc">
                  We’re committed to elevating the construction experience for
                  our clients. With a passion for innovation and quality
                  craftsmanship.
                </p> */}
                <p class="disc">Engineering with Intelligent Solutions.</p>
                <div class="social-area-wrapper-one">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/technolandengineers/">
                        <i class="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>

                    <li>
                      <a href="https://x.com/engineers20359">
                        <i class="fa-brands fa-x"></i>
                      </a>
                    </li>

                    <li>
                      <a href="https://www.linkedin.com/company/techno-land-engineers-and-surveyors/">
                        <i class="fa-brands fa-linkedin-in"></i>
                      </a>
                    </li>

                    {/* ✅ Instagram added */}
                    <li>
                      <a href="https://www.instagram.com/technoland_surveyors/">
                        <i class="fa-brands fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="footer-wrapper-right">
                <div class="single-nav-area-footer use-link">
                  <h4 class="title">Useful Links</h4>
                  <ul>
                    <li>
                      <Link to={"/about-us"}>
                        <i class="fa-regular fa-arrow-right-long"></i>About Us
                      </Link>
                    </li>
                    {/* <li><Link to='/gallery'><i class="fa-regular fa-arrow-right-long"></i>Our Gallery</Link>
                               </li> */}

                    <li>
                      <Link to="/career">
                        <i class="fa-regular fa-arrow-right-long"></i>Career
                      </Link>
                    </li>
                    <li>
                      <Link to="/blogs">
                        <i class="fa-regular fa-arrow-right-long"></i>Blogs
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact-us">
                        <i class="fa-regular fa-arrow-right-long"></i>Contact Us
                      </Link>
                      <li>
                        <Link to="/our-technologies">
                          <i class="fa-regular fa-arrow-right-long"></i>Our
                          Technologies
                        </Link>
                      </li>
                    </li>
                  </ul>
                </div>
                <div class="single-nav-area-footer use-link">
                  <h4 class="title">Quick Services</h4>
                  <ul>
                    <li>
                      <Link to="/land-survey">
                        <i class="fa-regular fa-arrow-right-long"></i>Land
                        Survey
                      </Link>
                    </li>
                    <li>
                      <Link to="/water-supply">
                        <i class="fa-regular fa-arrow-right-long"></i>Water
                        Supply
                      </Link>
                    </li>
                    <li>
                      <Link to="/irrigation-system">
                        <i class="fa-regular fa-arrow-right-long"></i>Irrigation
                      </Link>
                    </li>
                    <li>
                      <Link to="/soil-investigation">
                        <i class="fa-regular fa-arrow-right-long"></i>Soil
                        Investigation
                      </Link>
                    </li>
                    <li>
                      <Link to="/rain-water-harvesting">
                        <i class="fa-regular fa-arrow-right-long"></i>Rain Water
                        Harvesting
                      </Link>
                    </li>
                    <li>
                      <Link to="/property-liaising">
                        <i class="fa-regular fa-arrow-right-long"></i>Property
                        Liaisoning
                      </Link>
                    </li>
                  </ul>
                </div>
                <div class="single-nav-area-footer news-letter">
                  <h4 class="title">Contact Us</h4>
                  <ul>
                    <li style={{ cursor: "pointer" }}>
                      <a
                        href="tel:+918600082700"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <img src="/assets/images/about/call.png" alt="call" />
                        +91 8600082700
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a href="mailto:info@technolandsurvey.com">
                        {" "}
                        <img src="/assets/images/about/email .png" alt="logo" />
                        info@technolandsurvey.com
                      </a>
                    </li>
                    <li style={{ display: "flex", alignItems: "start" }}>
                      <img
                        src="/assets/images/about/location.png"
                        alt="logo"
                        style={{ marginRight: "10px", marginTop: "6px" }}
                      />
                      <a href="#">
                        Sr. no. 108. Plot no 12. Gangapur shivar, Front of
                        raghunandan resort, Dhruv Nagar, Nashik, Maharashtra,
                        India 422012.
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-full copyright-area-one">
          <div className="row">
            <div className="col-lg-12">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="copyright-wrapper">
                      {/* Main Line */}

                      {/* One Row Certification Line */}
                      <p className="mb-0">
                        Action / ISO 27001:2022 certified / Certificate No:
                        I91010420258568
                      </p>
                      <p className="mb-0">
                        Copyright © {new Date().getFullYear()} Techno Land
                        Engineers and Surveyors. All Rights Reserved.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebsiteFooter;
